import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import './i18n';
import App from './App';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <Suspense fallback={<div className="flex h-screen w-full items-center justify-center text-xl font-semibold">Loading...</div>}>
      <App />
    </Suspense>
  </React.StrictMode>
);
